import { render, staticRenderFns } from "./simple-social.vue?vue&type=template&id=1cbd8cf3&"
import script from "./simple-social.vue?vue&type=script&lang=js&"
export * from "./simple-social.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/planorama/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1cbd8cf3')) {
      api.createRecord('1cbd8cf3', component.options)
    } else {
      api.reload('1cbd8cf3', component.options)
    }
    module.hot.accept("./simple-social.vue?vue&type=template&id=1cbd8cf3&", function () {
      api.rerender('1cbd8cf3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/social-media/simple-social.vue"
export default component.exports